import {
  Component,
  computed,
  input,
  ChangeDetectionStrategy,
} from '@angular/core'
import { SkeletonLineComponent } from './skeleton-line/skeleton-line.component'

@Component({
  selector: 'wm-front-skeleton',
  imports: [SkeletonLineComponent],
  templateUrl: './skeleton.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './skeleton.component.scss',
})
export class SkeletonComponent {
  public maxNumberOfLine = input<number>(3)

  public numberOfLine = computed(() => {
    const choices = Array.from({ length: this.maxNumberOfLine() }).map(
      (_, i) => i + 1
    )
    const idx = Math.floor(Math.random() * choices.length)
    return choices[idx]
  })

  public lines = computed(() => Array.from({ length: this.numberOfLine() }))
}
